import React from 'react';
import PropTypes from 'prop-types';
import { StyledBenefitIcon, Name } from './styled';

const BenefitIcon = ({ name, iconSrc, onClick, isSelected }) => {
  return (
    <StyledBenefitIcon onClick={onClick} $isSelected={isSelected}>
      {iconSrc && <img src={iconSrc} alt={name} />}
      <Name>{name}</Name>
    </StyledBenefitIcon>
  );
};

BenefitIcon.propTypes = {
  name: PropTypes.string.isRequired,
  iconSrc: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isSelected: PropTypes.bool
};

export default BenefitIcon;
